import React from "react";

import { DateColumn } from "../cells/DateColumn";

export const QA_REPORT_COLUMNS = [
	{
		key: "dateStart",
		name: "Date Start",
		sortable: true,
		getRowMetaData(data){
			return data;
		},
		formatter({ dependentValues }){
			return <DateColumn value={dependentValues?.dateStart} />;
		},
	},
	{
		key: "dateEnd",
		name: "Date End",
		sortable: true,
		getRowMetaData(data){
			return data;
		},
		formatter({ dependentValues }){
			return <DateColumn value={dependentValues?.dateEnd} />;
		},
	},
	{
		key: "submittedLibraries",
		name: "Libraries with Creatives Submitted",
		sortable: true,
		getRowMetaData(data){
			return data;
		},
		formatter({ dependentValues }){
			return dependentValues?.submittedLibraries || 0;
		},
	},
	{
		key: "location",
		name: "Department",
		sortable: true,
		getRowMetaData(data) {
			return data;
		},
		formatter({ dependentValues }){
			return dependentValues?.location?.label || "";
		},
	},
];
